import { IconButton } from "@mui/material";
import React from "react";
import Button from "@mui/material/Button";
import TextBox from "../textboox/TextBox";
import DeleteIcon from "@mui/icons-material/Close";

import "./modal.css";

const Backdrop = (props) =>
  props.show ? <div className="Backdrop"></div> : null;

const Modal = (props) => {
  if (props.canShow) {
    return (
      <div className="modal_comp">
      <div className="modal_comp_content">
        <h2 className="page-header Modal-header">
         <div className="page-header__title">
         <i className="bx bx-box page-header__icon"></i>
          {props.modal_title}
         </div>
          <i className="page-header__icon" onClick={props.updateModalState}>
            <DeleteIcon/>
          </i>          
        </h2>

        <div  className="Modal-conten p-8">
          <div  className="flex justify-center items-center w-full">
          {props.children}
          </div>
        </div>
       

        <Backdrop show={props.canShow} />
      </div>
      
      </div>
    );
  }

  return null;
};

export default Modal;
